var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Box } from 'wix-style-react';
import { InfoLine } from './InfoLine';
export var InfoSection = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, content = _a.content, rest = __rest(_a, ["title", "subtitle", "content"]);
    var filteredContent = content
        .filter(Boolean)
        .map(function (subContent) { return subContent.toString(); });
    var renderTitle = function () {
        if (!title) {
            return undefined;
        }
        return (React.createElement(InfoLine, { clearPadding: true, weight: "bold" }, title));
    };
    var renderSubtitle = function () {
        if (!subtitle) {
            return undefined;
        }
        return (React.createElement(InfoLine, { clearPadding: !title, weight: "bold" }, subtitle));
    };
    var renderContent = function () {
        return filteredContent.map(function (subContent, index) { return (React.createElement(InfoLine, { key: "SubContent_".concat(index), clearPadding: index === 0 && !title }, subContent)); });
    };
    if (!title && !subtitle && filteredContent.length === 0) {
        return null;
    }
    return (React.createElement(Box, __assign({ direction: "vertical" }, rest),
        renderTitle(),
        renderSubtitle(),
        renderContent()));
};
//# sourceMappingURL=InfoSection.js.map